(function () { if (!LN.Core || !LN.Config) throw new Error("LN.Core || LN.Config missing"); })();

(function (Controller, Helper, Config, Model, Service, Handler, Analytics, FB, LocalStorage, $) {
    'use strict';

    Controller.accederFacebook = () => {

        window.FB && window.FB.Event.subscribe('auth.login', (response) => {
            console.log(response);
            console.log('FB auth.login ');
        });

        window.FB && window.FB.Event.subscribe('auth.statusChange', (response) => {
            if (response.status == 'connected') {
                //if (!Model.Window.islockedFacebook) {
                    //Model.Window.islockedFacebook = true;
                    console.log('FB auth.statusChange ');
                    //if (Controller.checkStorageSession()) {
                    //    return; // Otra sesi�n en progreso.
                    //}
                    Helper.resetAll(function () {
                        console.log('accederFacebookProcesar');
                        Service.getFbMe(Controller.accederFacebookProcesar);
                    });
                //}

            }
        });


        window.FB && window.FB.getLoginStatus( (response) => {
            if (response.status == 'connected') {
                console.log('FB auth.getLoginStatus ');
                //if (!Model.Window.islockedFacebook) {
                    //Model.Window.islockedFacebook = true;
                    //if (Controller.checkStorageSession()) {
                    //    return; // Otra sesi�n en progreso.
                    //}
                    Helper.resetAll(function () {
                        console.log('accederFacebookProcesar');
                        Service.getFbMe(Controller.accederFacebookProcesar);
                    });
                //}
            }
            else {
                console.log('FB NO logueado');
                window.FB.login((response) => {
                    console.log("fb.login");
                }, {
                        scope: 'email',
                        return_scopes: true
                    });
            }
        });

        Analytics.clickSSO('Facebook');

    }

    Controller.accederFacebookProcesar = function (fbObject) {
        Model.Usuario.UsuarioFacebookId = fbObject.id;
        Model.Usuario.UsuarioDetalleNombre = fbObject.first_name;
        Model.Usuario.UsuarioDetalleApellido = fbObject.last_name;
        Model.Usuario.FbEmail = fbObject.email;
        Model.Usuario.FbFirstName = fbObject.first_name;
        Model.Usuario.FbLastName = fbObject.last_name;
        Model.Usuario.FbGender = fbObject.gender;
        Model.Usuario.FbLocale = fbObject.locale;
        Model.Usuario.AccessToken = window.FB.getAuthResponse()['accessToken'];
        Service.ajaxPost('/Usuario/GestionarRedSocial', Model.Usuario, function (data, status, xhr) {
            if (!Helper.isEmpty(data.code)) {
                var token = xhr.getResponseHeader("X-Token") || Helper.getHeader(data.response, [1]);
                var xvalue = xhr.getResponseHeader("X-Value") || Helper.getHeader(data.response, [2]);

                if ((data.code == "0000") && (token == null || xvalue == null || !token || !xvalue)) {
                    logger && logger.error('GestionarRedSocial (FB) ACCEDER | sin headers', { token, xvalue});
                }
                if (data.code == '0000') Service.storeFB(fbObject);
                Handler.loginResponseHandler(data, status, xhr);
            }
        }, false, {
            showPreloader: true
        });
    }

    Controller.accederFacebookAutomatico = function (id) {
        window.FB && FB.getLoginStatus((response) => {
            if (response.status == 'connected') {
                //if (!Model.Window.islockedFacebook) {
                    //Model.Window.islockedFacebook = true;
                    //if (Controller.checkStorageSession()) {
                    //    return; // Otra sesi�n en progreso.
                    //}
                    Helper.resetAll(function () {
                        Service.getFbMe(Controller.accederFacebookProcesar);
                    });
                //}
            }
        });

    }

    Controller.asociarFacebook = () => {
        window.FB && window.FB.login((response) => {
            if (response.authResponse) {
                window.FB.api('/me?fields=name,email,age_range,currency,first_name,last_name,gender,locale,birthday,hometown,location', (response) => {
                    Controller.asociarFacebookProcesar(response);
                });
            }
        }, {
            scope: 'email'
        });
    }

    Controller.asociarFacebookProcesar = function (fbObject) {
        Model.Usuario.UsuarioFacebookId = fbObject.id;
        Model.Usuario.AccessToken = window.FB.getAuthResponse()['accessToken'];
        Model.Usuario.xToken = Helper.readCookie('token');
        Model.Usuario.xKey = Math.random();
        Service.ajaxPost('/Usuario/AsociarFacebook', Model.Usuario, function (data, status, xhr) {
            if (!Helper.isEmpty(data.code)) {
                var token = xhr.getResponseHeader("X-Token");
                var xvalue = xhr.getResponseHeader("X-Value");
   
                if ((data.code == "0000") && (token == null || xvalue == null || !token || !xvalue)) {
                    logger && logger.error('GestionarRedSocial (FB) ASOCIAR | sin headers', { token, xvalue});
                }
                Handler.asociarRedSocialResponseHandler(data, status, xhr);
            }
        }, false, {
            showPreloader: true,
            sentHeader: true
        });
    }

})(LN.Controller, LN.Helper, LN.Config, LN.Model, LN.Service, LN.Handler, LN.Analytics, window.FB, LN.LocalStorage, jQuery);


// WEBPACK FOOTER //
// ./Statics/scripts/login/controllers/facebook.js